/**
 * @module VerifyResultTableShell
 * @description Phase 18 extraction of the shared verify result table chrome.
 * Provides the common header/body shell used by result tables with title and row content props.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Trans } from '@lingui/macro';
import { Table, TableHead, TableRow, TableCell, TableBody } from '@material-ui/core';
import useStyles from './VerifyResultStyles';

/**
 * Shared table shell for verify result tables.
 * Renders the common Table + Head (title + nPoint/Result headers) + Body structure.
 */
function VerifyResultTableShell({ title, resultColumnLabel, children }) {
    const classes = useStyles();

    return (
        <Table size="small" className={classes.verifyTable} style={{ width: 'auto' }}>
            <TableHead>
                <TableRow>
                    <TableCell colSpan={2}>{title}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell className={classes.pulseNameCell}>
                        <Trans>nPoint</Trans>
                    </TableCell>
                    <TableCell>{resultColumnLabel || <Trans>Results</Trans>}</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>{children}</TableBody>
        </Table>
    );
}

VerifyResultTableShell.propTypes = {
    title: PropTypes.node.isRequired,
    resultColumnLabel: PropTypes.node,
    children: PropTypes.node,
};

VerifyResultTableShell.defaultProps = {
    resultColumnLabel: null,
    children: null,
};

export default VerifyResultTableShell;
